import { typographyTokens } from '../../../../theme/typographyTokens';
// TaskDependencyMapping.tsx (parent)
import React, { useState } from 'react';
import { Paper, Typography, Box, TextField, Button, Autocomplete } from '@mui/material';
import WorkflowValidationTable from './WorflowValidationTable';
import { useGetAllSEPIDsQuery } from '../../../../../frontend/services/sepSlice';


// Interface for SEP object
export interface SepOption {
  id: number;
  name: string;
}

const WorkflowValidation = () => {
  const [searched, setSearched] = useState(false);
  const [selectedSeps, setSelectedSeps] = useState<SepOption[]>([]);
  const { data: sepIDs, error, isLoading } = useGetAllSEPIDsQuery();

  // Map API response to SEP options for Autocomplete
  const sepOptions: SepOption[] = Array.isArray(sepIDs)
    ? sepIDs.map((sep: any) => ({ id: sep.id, name: sep.name }))
    : [];

  return (
    <Box sx={{ width: '100%', overflowX: 'auto' }}>
      <Paper sx={{ p: 3, mb: 4, borderRadius: 2, boxShadow: 2 }}>
        <Typography sx={{ fontWeight: typographyTokens.fontWeights.bold, fontSize: typographyTokens.fontSizes.xl, mb: 2 }}>
          SEP Workflow Validation
        </Typography>
        {isLoading ? (
          <Typography sx={{ fontSize: typographyTokens.fontSizes.base, color: '#2372B9', mt: 2 }}>
            Loading SEP list...
          </Typography>
        ) : error ? (
          <Typography sx={{ fontSize: typographyTokens.fontSizes.base, color: 'error.main', mt: 2 }}>
            Failed to load SEP list. Please try again later.
          </Typography>
        ) : (
          <>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Autocomplete
                multiple
                options={sepOptions}
                getOptionLabel={(option) => `${option.id} - ${option.name}`}
                value={selectedSeps}
                sx={{ minWidth: '100%', flexGrow: 1 }}
                onChange={(_event, value) => setSelectedSeps(value)}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField {...params} label="Select SEP(s)" variant="outlined" margin="normal" sx={{ fontSize: typographyTokens.fontSizes.body, width: '100%' }} />
                )}
              />
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
              <Button
                variant="contained"
                sx={{
                  margin: '16px 0px 10px 0px',
                  backgroundColor: '#2372B9',
                  textTransform: 'none',
                }}
                onClick={() => {
                  setSearched(false);
                  if (selectedSeps.length > 0) {
                    setSearched(true);
                  }
                }}
              >
                VALIDATE
              </Button>
              <Button
                variant="outlined"
                sx={{ margin: '16px 0px 10px 0px', textTransform: 'none' }}
                onClick={() => {
                  setSelectedSeps([]);
                  setSearched(false);
                }}
              >
                CLEAR
              </Button>
            </Box>
          </>
        )}
      </Paper>
      {searched && selectedSeps.length > 0 && (
        <WorkflowValidationTable selectedSeps={selectedSeps} />
      )}
    </Box>
  );
};

export default WorkflowValidation;

